import React from "react";
import { Button } from "./Button";
import Modal from "./Modal";

const SimpleModal = ({ title, onClose, onSubmit, children, buttonText }) => (
  <Modal>
    <div
      style={{
        background: "#fff",
        padding: "24px",
        borderRadius: "20px",
        width: "400px",
        maxWidth: "100%",
        position: "relative",
        boxShadow: "0 30px 80px rgba(14, 20, 27, 0.3)",
        fontFamily: "inherit",
      }}
    >
      <div
        style={{
          fontSize: "1.08rem",
          fontWeight: 800,
          marginBottom: "18px",
          color: "#0E141B",
        }}
      >
        {title}
      </div>
      <div style={{ marginBottom: "24px" }}>{children}</div>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
        <Button
          onClick={onClose}
          backgroundColor="#F4F8F7"
          color="#3A434E"
          border="none"
        >
          취소
        </Button>
        <Button
          onClick={onSubmit}
          backgroundColor="#0E141B"
          color="#fff"
          border="none"
        >
          {buttonText}
        </Button>
      </div>
    </div>
  </Modal>
);

export default SimpleModal;
